import { MarketFilter, OddsFormat } from '../../../common/Foundation';

export const marketKeys = {
  _1Line: {
    key: MarketFilter._1Line,
    text: '1 Line',
  },
  _3Lines: {
    key: MarketFilter._3Lines,
    text:  '3 Lines',
  },
  _5Lines: {
    key: MarketFilter._5Lines,
    text: '5 Lines',
  },
  All: {
    key: MarketFilter.All,
    text: 'AllMarkets',
  },
}

export const oddsFormatKeys = {
  Decimal: {
    key: OddsFormat.Decimal,
    icon: 'decimal',
  },
  HongKong: {
    key: OddsFormat.HongKong,
    icon: 'hongkong',
  },
  Indonesian: {
    key: OddsFormat.Indonesian,
    icon: 'indonesian',
  },
  Malay: {
    key: OddsFormat.Malay,
    icon: 'malay',
  },
  American: {
    key: OddsFormat.American,
    icon: 'american',
  },
}

export const selectLeagueOptionKeys = {
  betTypeGroup: 'betTypeGroup',
  country: 'country', 
  mode: 'mode',
  market: 'market',
  eSports: 'eSports',
  outright: 'outright',
  parlay: 'parlay',
  sportId: 'sportId',
  timeFilter: 'timeFilter',
  filterOptions: 'filterOptions',
  favourite: 'favourite',
  favouriteLeagueId: 'favouriteLeagueId',
  isTopLeague: 'isTopLeague',
  topLeagueLeagueId: 'topLeagueLeagueId',
  period: 'period'
}



// WEBPACK FOOTER //
// ./src/app/components/CompactView/ViewOptionsComponent/constants.js